
namespace Matrix.Workflow {

    @Serenity.Decorators.registerClass()
    export class ClientFunctionSummaryDialog extends SiteEntityDialog<ClientFunctionRow, any> {
        protected getFormKey() { return ClientFunctionSummaryForm.formKey; }
        protected getIdProperty() { return ClientFunctionRow.idProperty; }
        protected getLocalTextPrefix() { return ClientFunctionRow.localTextPrefix; }
        protected getNameProperty() { return ClientFunctionRow.nameProperty; }
        protected getService() { return ClientFunctionService.baseUrl; }

        protected form = new ClientFunctionSummaryForm(this.idPrefix);

        constructor() {
            super();

            $(window).on('resize.' + this.uniqueName, () => this.arrange());
        }

        getEntityTitle() {
            return "Function History";
        }

        destroy() {
            $(window).off('.' + this.uniqueName);
            super.destroy();
        }

        protected arrange() {
            super.arrange();
            var availHeight = $(window).height() - 305;
            this.form.InvocationHistory.element.css('height', Math.max(150, availHeight) + 'px').trigger('layout');
        }

        useViewMode() {
            return true;
        }

        afterLoadEntity() {
            super.afterLoadEntity();
            if (this.form.WorkflowInstanceId.value!= null) {
                this.form.WorkflowInstanceId.getGridField().toggle(true);
                this.setWorkflowInsId();
            }
            else {
                this.form.WorkflowInstanceId.getGridField().toggle(false);
            }

            this.form.InvocationHistory.functionName = this.entity.FunctionName;
        }

        updateInterface() {
            super.updateInterface();
            this.toolbar.element.hide();
        }

        protected setWorkflowInsId() {

            if ($(".workflow").length < 1) {
                $('<a class="workflow" href="' + Q.resolveUrl("~/Workflow/WorkflowInstance#edit/" + this.form.WorkflowInstanceId.value) + '">' + this.form.WorkflowInstanceId.value + '</a>')
                    .insertAfter(this.form.WorkflowInstanceId.element)
            }
            $("[name='WorkflowInstanceId']").addClass("s-clientfunctioninvocation-invisible");
        }
    }
}